<micro-select-combo #sel
              placeholder="Airtime Product Type"
              [mode]="mode"
              [(id)]="airtimeStatusId"
              (idChange)="change($event)"
              [options]="options"

              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
